// @ts-nocheck
import { Plugin } from '/root/workspace/ccrc-health-management_9dhi/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','layout','layoutActionRef','request','qiankun',],
});

export { plugin };
